import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

class CastDetail extends Component {
  render() {
    console.log(this.props.castInfo);
    const {
      name,
      gender,
      biography,
      place_of_birth,
      birthday,
      profile_path,
      known_for_department,
      imdb_id
    } = this.props.castInfo;
    return (
      <div className="cast-detail">
        <div className="cast-detail__header">
          <p>{name}</p>
          <div className="cast-detail__avatar">
            <img
              src={`https://image.tmdb.org/t/p/w200/${profile_path}`}
              alt="avatar"
            />
          </div>
        </div>
        <div className="cast-detail__content">
          <div className="cast-detail__content--left">
            <div className="cast-detail__row">
              <p className="cast-detail__row-heading">Known for department:</p>
              <p className="cast-detail__row-paragraph">
                {known_for_department}
              </p>
            </div>
            <div className="cast-detail__row">
              <p className="cast-detail__row-heading">Birthday:</p>
              <p className="cast-detail__row-paragraph">{birthday}</p>
            </div>
            <div className="cast-detail__row">
              <p className="cast-detail__row-heading">Gender:</p>
              <p className="cast-detail__row-paragraph">
                {gender === 2 ? "Male" : "Female"}
              </p>
            </div>
            <div className="cast-detail__row">
              <p className="cast-detail__row-heading">Place of birth:</p>
              <p className="cast-detail__row-paragraph">{place_of_birth}</p>
            </div>
          </div>
          <div className="cast-detail__content--right">
            <p className="cast-detail__row-heading">Biography</p>
            <p className="cast-detail__row-paragraph">{biography}</p>
            <div className="cast-detail__row button">
              {imdb_id && (
                <li>
                  <a
                    href={`https://www.imdb.com/name/${imdb_id}/?ref_=nv_sr_srsg_0`}
                    class="btn btn__action btn__black"
                    target="_blank"
                  >
                    IDMB
                    <svg>
                      <use xlinkHref="../images/sprite.svg#icon-imdb"></use>
                    </svg>
                  </a>
                </li>
              )}
              <li>
                <Link to="/" class="btn  btn__action btn__black">
                  Back
                  <svg>
                    <use xlinkHref="../images/sprite.svg#icon-arrow-back"></use>
                  </svg>
                </Link>
              </li>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    castInfo: state.castInfo
  };
};

export default connect(mapStateToProps, null)(CastDetail);
